export const BASE_URL = '/promo/worldcup_2026/'
export const PAGE_SIZE = 10

export const LEVEL_OPTIONS = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
]

export const LEVEL_FILTER = [
  {
    text: '1',
    value: 1,
  },
  {
    text: '2',
    value: 2,
  },
  {
    text: '3',
    value: 3,
  },
]

export const TASKS_TYPES_NAMES = {
  new_client: 'Invite 1 new active client',
  ct_copy: 'Follow a strategy in Headway Copytrade',
  field_sharing: 'Share your football team on Facebook',
  trade_3_days: 'Trade for 3 days in a row',
  trade_5_days: 'Trade for 5 days in a row',
  trade_7_days: 'Trade for 7 days in a row',
  tg_mini_app_deposit: 'Make a deposit in Telegram Mini App',
  text_review: 'Leave a review',
  video_review: 'Share your Headway journey in a video',
} as const

export const PRIZE_TYPES = {
  hisense: '4K laser projector',
  macbook: 'Apple MacBook Pro 16',
  iphone: 'iPhone 17 Pro Max',
  play_station_top_field: 'PlayStation 5 Pro',
  nintendo: 'Nintendo Switch 2',
  play_station_raffle: 'PlayStation 5 Pro',
  fc_26: 'EA Sports FC 26',
  meta_quest: 'Meta Quest 3S',
  gold_1g: '1g Gold FIFA World Cup Trophy 2026',
  ball: 'FIFA World Cup 2026 football',
  t_shirt: 'Custom T-shirt',
  usd_25: '25 USD',
  sony_headphones: 'Sony WH-1000XM6',
  usd_5: '5 USD',
} as const

export const prizeTypesOptions = Object.entries(PRIZE_TYPES).map(
  ([key, value]) => ({
    label: value,
    value: key as keyof typeof PRIZE_TYPES,
  }),
)
